import React, { createContext, useContext, useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { zohoApi } from "../zohoApi";

const STALE_TIME = 60 * 60 * 1000; // 1 hour

const ZohoAuthContext = createContext();

export const ZohoAuthProvider = ({ children, height, width }) => {
  const [localData, setLocalData] = useState();
  const { zuid, orgId, apiKey, zapiKey, dataCenterUrl } = localData || {};

  const handleGrantAuth = async () => {
    if (zuid && orgId && apiKey && zapiKey && dataCenterUrl) {
      const { data } = await zohoApi.auth.handleAuthenticateZoho({
        zuid,
        orgId,
        apiKey,
        zapiKey,
        dataCenterUrl,
      });
      setLocalData((prev) => ({
        ...prev,
        zohoAuthenticated: data?.zohoAuthenticated,
        accessToken: data?.accessToken,
      }));
    }
  };

  const handleRevokeAuth = async () => {
    if (orgId && apiKey) {
      const { data } = await zohoApi.auth.handleRevokeZoho({ orgId, apiKey });
      setLocalData((prev) => ({
        ...prev,
        zohoAuthenticated: data?.zohoAuthenticated,
        accessToken: data?.accessToken,
      }));
    }
  };

  const { isFetching, data: temp } = useQuery({
    queryKey: ["zohoInitialCredentials"],
    queryFn: async () => {
      const data = await zohoApi.auth.initializeZohoAuth({ height, width });
      return data;
    },
    staleTime: STALE_TIME,
  });

  useEffect(() => {
    if (temp && !localData) {
      setLocalData(temp?.data);
    }
  }, [temp, localData]);

  const value = {
    handleGrantAuth,
    handleRevokeAuth,
    authLoadingZoho: isFetching || !localData,
    ...localData,
  };

  return (
    <ZohoAuthContext.Provider value={value}>
      {children}
    </ZohoAuthContext.Provider>
  );
};

export const useZohoAuthContext = () => {
  const context = useContext(ZohoAuthContext);
  if (!context) {
    throw new Error(
      "useZohoAuthContext must be used within a ZohoAuthProvider"
    );
  }
  return context;
};
